import Alpine from 'alpinejs';

Alpine.data('toast', () => ({
  message: '',
  timeout: null,
  type: 'info',

  get classList() {
    return {
      'bg-secondary-500 text-white': this.type === 'success',
      'bg-red-500 text-white': this.type === 'error',
      'bg-blue-500 text-white': this.type === 'info',
    };
  },

  events: {
    ['x-on:click']() {
      this.close();
    },
    ['x-on:keydown.escape.window']() {
      this.close();
    },
    ['x-on:toast:show.window'](event) {
      const { message, duration, type } = event.detail;
      this.show(message, duration, type);
    },
  },

  close() {
    this.$root.close();
  },

  show(message, duration = 3000, type = 'info') {
    this.message = message;
    this.type = type;
    this.$root.showModal();

    clearTimeout(this.timeout);
    
    this.timeout = setTimeout(() => {
      this.close();
    }, duration);
  },
}));